import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { Error401Component } from './error401/error401.component';
import { Error404Component } from './error404/error404.component';
import { Error500Component } from './error500/error500.component';

const routes: Routes = [
 {
    path: 'auth',
    loadChildren: () => import('src/app/auth/auth.module').then(m => m.AuthModule)
    },
  {
    path: '',
    loadChildren: () => import('src/app/views/views.module').then(m => m.ViewsModule)
  },
  
  {
    path: '404',
    component: Error404Component
  },
  {
    path: '401',
    component: Error401Component
  },
  {
    path: '500',
    component: Error500Component
  },
  {
    path: '**',
    redirectTo: '404',
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
